import Vue from 'vue';
import Vuex, { Dispatch } from 'vuex';
import VueAxios from 'vue-axios';
import axios from 'axios';

import usermanagement from './usermanagement';
import tenancy from './tenancy';
import locations from './locations';
import activities from './activities';
import devices from './devices';
import types from './types';
import controllers from './controllers';
import notifications from './notifications';
import tools from './tools';
import energy from './energy';
import reports from './reports';
import events from './events';

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const store = new Vuex.Store({
	modules: {
		tenancy,
		usermanagement,
		locations,
		activities,
		devices,
		types,
		controllers,
		tools,
		notifications,
		energy,
		reports,
		events,
	},
	actions: {
		async fetchAllData({ dispatch }: { dispatch: Dispatch }) {
			await Promise.all([
				dispatch('usermanagement/fetchUser'),
				dispatch('locations/fetchAllLocations'),
				dispatch('activities/fetchAllActivities'),
				dispatch('devices/fetchAllDevices'),
				dispatch('types/fetchAllTypes'),
				dispatch('controllers/fetchAllControllers'),
				dispatch('notifications/fetchAll'),
			]);
		},

		cleanAllData({ dispatch }: { dispatch: Dispatch }) {
			dispatch('usermanagement/cleanFullUser');
			dispatch('tenancy/cleanAllTenancy');
			dispatch('locations/cleanAllLocations');
			dispatch('activities/cleanAllActivities');
			dispatch('devices/cleanAllDevices');
			dispatch('types/cleanAllTypes');
			dispatch('controllers/cleanAllControllers');
			dispatch('notifications/cleanAll');
			dispatch('energy/cleanAllEnergy');
			dispatch('reports/cleanAllReports');
			dispatch('events/cleanAllEvents');
			dispatch('tools/cleanAllTools');
		},

		async cleanSiteData({ dispatch }: { dispatch: Dispatch }) {
			await Promise.all([
				dispatch('locations/cleanAllLocations'),
				dispatch('activities/cleanAllActivities'),
				dispatch('devices/cleanAllDevices'),
				dispatch('types/cleanAllTypes'),
				dispatch('controllers/cleanAllControllers'),
				dispatch('notifications/cleanAll'),
				dispatch('energy/cleanAllEnergy'),
				dispatch('reports/cleanAllReports'),
				dispatch('events/cleanAllEvents'),
				dispatch('tools/cleanAllTools'),
			]);
		},
	},
});

axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		const {
			response: { status },
		} = error;

		if (store.getters['usermanagement/authentication/getLoggedIn'] && status === 401) {
			store.dispatch('usermanagement/authentication/logOut');
			window.location.href = `${window.location.origin}`;
		} else {
			return Promise.reject(error);
		}
	}
);

export default store;
